import React, { FC } from 'react'
import { IconType } from '@bt-react/components/Icon'
import SidePanelFramework from '@bt-react/components/SidePanelFramework'
import List from '@bt-react/components/List'
import { SessionStatusPanelProps } from './types'
import style from './SessionStatusPanel.module.scss'

const SessionStatusPanel: FC<SessionStatusPanelProps> = props => {

  const outputEvents = (): React.JSX.Element[] =>
    [ ...props.eventLog ]
      .reverse()
      .map((event, i) =>
        <>
          <div key={`session-status-event-key-${i}`} data-bdd={`session-status-log-event-${i}`} className={style['session-status-title']}>{event.event}</div>
          <div key={`session-status-event-value-${i}`} data-bdd={`session-status-log-dstamp-${i}`} className={style['session-status-value']}>{event.dstamp.split('T')[1].substring(0, 8)}</div>
        </>
      )

  const renderStatuses = (): React.JSX.Element[] => [
    <><div className={style['session-status-title']}>Sync Client Status:</div><div data-bdd='session-status-sync-client' className={style['session-status-value']}>{props.syncClientStatus}</div></>,
    <><div className={style['session-status-title']}>Room Status:</div><div data-bdd='session-status-room' className={style['session-status-value']}>{props.roomStatus}</div></>
  ]

  return <SidePanelFramework
    icon={IconType.iconName.status}
    title='Session Status'
    dataBdd='side-panel-session-status'
    content={
      <>
        <List
          content={renderStatuses()}
          separated={true}
          size={'large'}
        />
        <List
          content={outputEvents()}
          separated={true}
          size='large'
          header={{
            title: 'Connection Event Log (Last 10 entries)',
            dataBdd: 'session-status-event-log-header'
          }}
        />
      </>
    }
  />

}

export default SessionStatusPanel
